const normalizar = texto =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

// Objetos que não aparecem no grid "Clique nos objetos que você deseja inserir
// na sua atividade" (/activity/create e /activity/create/:id).
//
// O corte é só de VITRINE: acontece no render do ActivityCreator, e `state.types`
// segue completo. Atividade antiga que já tenha um desses objetos continua
// exibindo nome, ícone e cor certos na lista de selecionados — o professor
// simplesmente não consegue inserir um novo.
//
// Trilha tem a própria lista, em `minhasTrilhas.js` (TRILHA_TIPOS_OCULTOS): são
// regras de telas diferentes, e juntá-las faria um lado herdar escondido o que
// o outro decidiu.
const ATIVIDADE_TIPOS_OCULTOS = ["Áudio", "Editor", "Link", "Literarte"];

export const isTipoOcultoNaAtividade = nome =>
  ATIVIDADE_TIPOS_OCULTOS.some(tipo => normalizar(tipo) === normalizar(nome));
